var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"glow-image",style:({width: _vm.size+'px'})},[_c('div',{staticClass:"album-art album-background",style:({
                backgroundImage: `url(${_vm.image})`,
                opacity: _vm.$vuetify.theme.dark ? 0.4 : 0.7,
                minWidth: _vm.size + 'px',
                height: _vm.size + 'px',
                right: (-_vm.size / 2) + 'px',
                borderRadius: _vm.rounded ? '50%' : '5px',
                top: (_vm.size / 16) + 'px',
                filter: `blur(${_vm.size / 16}px)`,
             })}),_c('div',{staticClass:"album-art album-normal",style:({
        backgroundImage: `url(${_vm.image})`,
        minWidth: _vm.size+'px',
        height: _vm.size+'px',
        left: (-_vm.size/2)+'px',
        borderRadius: _vm.rounded ? '50%' : '5px',
    })})])
}
var staticRenderFns = []

export { render, staticRenderFns }